import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'

export default function({ env }, inject) {
  mapboxgl.accessToken = env.mapboxglAccessToken || ''
  inject('mapboxgl', mapboxgl)
  inject('mapboxGeocoder', MapboxGeocoder)
}
